import { render, staticRenderFns } from "./totalSessionsReport.vue?vue&type=template&id=2c1bf57a&"
import script from "./totalSessionsReport.vue?vue&type=script&lang=js&"
export * from "./totalSessionsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports